











import Vue from 'vue'
import { Component, Ref } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { Snack, SnackType } from '@/interfaces/snack'

@Component
export default class AppSnack extends Vue {
  name = 'AppSnack'

  get showSnackbar (): boolean {
    return this.snacks.length > 0
  }

  get snackMsg (): string {
    const msg = this.snacks[0] ? this.snacks[0].msg : ''
    return msg
  }

  get snackColor (): string {
    return this.snacks[0] ? this.snacks[0].type : ''
  }

  @State(state => state.snacks.snacks) snacks!: Snack[]
}
